import { modal } from '../types'


export const closeModalAction = () => ({
    type: modal.CLOSE_MODAL,
    payload: {}
});

export const openCustomModal = ({ modalComponent, heading, modalWidth, modalHeight }) => ({
    type: modal.OPEN_CUSTOM_MODAL,
    payload: { modalComponent, heading, modalWidth, modalHeight }
})
